import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export {
  GroupContainer,
  PreviewToggleButton as PreviewButton,
} from '@/configuration/pages/ConfigurationPage/sharedStyles'

export const GroupSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.primary};

  &:first-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius3} ${props => props.theme.primitives.radius.radius3}
      ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0};
  }

  &:last-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
      ${props => props.theme.primitives.radius.radius3} ${props => props.theme.primitives.radius.radius3};
  }

  &:first-of-type:last-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius3};
  }
`

export const SectionDivider = styled.div`
  padding: 0 ${props => props.theme.spacing.sp16};
`

export const GroupSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
`

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.sp40};
`

export const ColorPickerContainer = styled.div`
  width: 100%;
`

export const ImageAndLinkContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
